import dayjs from "dayjs"
import { RecoveryComponentSettings } from "../../../domain/invoicing/settings/recoveryComponent"
import { PaymentFeesView, toPaymentFeesView } from "../../paymentFees/paymentFeesModel"

export type PassOnPaymentFeesView = PaymentFeesView & {
  isOn: boolean
  ratesReadAtText: string | null
}

export const shouldShowPassOnPaymentFeesSettings = (
  settings: RecoveryComponentSettings | undefined
): settings is RecoveryComponentSettings => {
  return settings !== undefined && settings.featureEnabled
}

export const toPassOnPaymentFeesView = (settings: RecoveryComponentSettings): PassOnPaymentFeesView => {
  const view = toPaymentFeesView(settings.cardSurcharge, settings.bankSurcharge)
  return {
    ...view,
    isOn: settings.enabled,
    ratesReadAtText: view.rows.length > 0 && settings.ratesLastUpdatedAt ? dayjs(settings.ratesLastUpdatedAt).format('MMM D, YYYY') : null
  }
}
